import { Snackbar } from "@material-ui/core";

import { getAllFamilies } from "../../reduxSaga/actions";
import { useSelector, useDispatch } from "react-redux";

import { useEffect, useState } from "react";
import AddFamily from "../../ui/AddFamily";
import ConfirmAddSubFamily from "../../ui/ConfirmAddSubFamily";
import { Alert } from "@material-ui/lab";
import getCurrentUserId from "./../../reduxSaga/sagas/requests/currentUserId";
import ProductService from "../../services/ProductService";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
const AddSubFamilies = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const availableFamilies = useSelector(
    (state) => state.staff.availableFamilies
  );
  const animatedComponents = makeAnimated();
  const [familySelectPlaceHolder, setFamilySelectPlaceHolder] = useState(
    "Choisir une famille de produits"
  );
  const [selectedOptionFamily, setSelectedOptionFamily] = useState(null);

  const [familyId, setFamilyId] = useState(0);
  const [allFamilly, setAllFamilly] = useState([]);

  const [subFamilyName, setSubFamilyName] = useState("");

  const [subFamilyDesc, setSubFamilyDesc] = useState("");
  const [confirmSubFamilyModel, setConfirmSubFamilyModel] = useState();
  const [onAddFamily, setOnAddFamily] = useState(false);
  const [onConfirmAddSubFamily, setOnConfirmAddSubFamily] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [isCancel, setIsCancel] = useState(false);
  const [typeFamily, setTypeFamily] = useState("");

  useEffect(() => {
    dispatch(getAllFamilies(0));
  }, []);

  const styles = {
    container: (base) => ({
      ...base,
      flex: 1,
    }),
  };

  useEffect(() => {
    if (
      onConfirmAddSubFamily === false &&
      confirmSubFamilyModel != null &&
      isCancel === false
    ) {
      setOpenSuccessAlert(true);
      setSuccessAlertText("Ajouté avec succès");
    }
  }, [onConfirmAddSubFamily]);

  useEffect(() => {
    setAllFamilly([]);

    availableFamilies &&
      availableFamilies.map((element, i) => {
        if (i === 0) {
          setFamilyId(element.id);
          setTypeFamily(element.type);
        }
        setAllFamilly((oldArray) => [
          ...oldArray,
          {
            value: element.id,
            label: element.name,
            customElements: element.type,
          },
        ]);
      });
  }, [availableFamilies]);

  const onChangeNameHandler = (event) => {
    setSubFamilyName(event.target.value);
  };

  const onChangeDescriptionHandler = (event) => {
    setSubFamilyDesc(event.target.value);
  };

  const onAddFamilyHandler = () => {
    setOnAddFamily(true);
  };
  const onChangeSelectedFamily = (selectedOption) => {
    setSelectedOptionFamily();
    setFamilyId(selectedOption.value);
    setFamilySelectPlaceHolder(selectedOption.label);
    setTypeFamily(selectedOption.customElements);
  };

  const onValidSubFamilyHandler = () => {
    if (subFamilyName === "") {
      setErrorAlertText("Erreur :le champ du nom est vide ! ");
      setOpenErrorAlert(true);
    } else if (familyId === 0) {
      setErrorAlertText("Erreur :le champ du famille est vide ! ");
      setOpenErrorAlert(true);
    } else {
      let confirmSubFamilyModel = {
        subFamilyName: subFamilyName,
        description: subFamilyDesc,
        idProductFamily: familyId,
        idUserCreation: getCurrentUserId(),
      };
      ProductService.addProductSubFamily(confirmSubFamilyModel).then(
        (result) => {
          if (result.data["success"]) {
            setOpenSuccessAlert(true);
            setSuccessAlertText("Enregistrement avec succées");
            setTimeout(() => {
              navigate(`/subFamilies`);
            }, 2000);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur :erreur serveur ");
          }
        }
      );
    }
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const addButtonFamily = () => {
    return (
      <button
        class="btn btn-dark"
        onClick={(e) => {
          navigate("/addFamily");
        }}
      >
        <i class="fas fa-plus"></i>
      </button>
    );
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">Ajouter Sous-Famille</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h5 className="card-title">
                    {" "}
                    Ajouter une sous-famille de produit
                  </h5>
                </div>
                <div className="card-body">
                  <div class="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Libellé</label>
                        <input
                          placeholder="Ajouter libellé "
                          onChange={onChangeNameHandler}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="form-group">
                        <div>
                          <label>Choisir la famille</label>
                          <div className="input-group">
                            <div
                              className="input-group-prepend"
                              style={{ width: "90%" }}
                            >
                              <Select
                                styles={styles}
                                closeMenuOnSelect={true}
                                components={animatedComponents}
                                defaultValue={selectedOptionFamily}
                                onChange={onChangeSelectedFamily}
                                // autosize={false}
                                options={allFamilly}
                                placeholder={familySelectPlaceHolder}
                                // menuPlacement={"top"}
                                // menuPosition={"fixed"}
                              />
                            </div>
                            <div className=" input-group-append">
                              {addButtonFamily()}
                              {/* <button
                                class="btn btn-dark "
                                onClick={onAddFamilyHandler}
                              >
                                <i class="fas fa-plus"></i>
                              </button> */}
                            </div>
                          </div>
                          {/* <select
                            value={familyId || null}
                            onChange={(e) => setFamilyId(e.target.value)}
                            className="form-control select2"
                            style={{ width: "100%" }}
                          >
                            {availableFamilies &&
                              availableFamilies.map((element, index) =>
                                index === 0 ? (
                                  <option
                                    key={element.id}
                                    value={element.id}
                                    selected="selected"
                                  >
                                    {element.name}
                                  </option>
                                ) : (
                                  <option key={element.id} value={element.id}>
                                    {element.name}
                                  </option>
                                )
                              )}
                          </select> */}
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-sm-2">
                      <div className="form-group" style={{ marginTop: 32 }}>
                        <button
                          class="btn btn-light "
                          onClick={onAddFamilyHandler}
                        >
                          <i class="fas fa-plus"></i>
                          Ajouter
                        </button>{" "}
                      </div>
                    </div> */}
                  </div>
                  <div className="row">
                    <div className="form-group col-sm-12">
                      <label htmlFor="inputDescription">Description</label>
                      <textarea
                        placeholder="Saisir..."
                        onChange={onChangeDescriptionHandler}
                        id="inputDescription"
                        className="form-control"
                        rows={4}
                        defaultValue={""}
                      />
                    </div>
                  </div>
                </div>
                <div class="card-footer" style={{ marginTop: "1%" }}>
                  <button
                    class="btn btn-dark float-right"
                    style={{ marginTop: "1%" }}
                    onClick={onValidSubFamilyHandler}
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      {onAddFamily && <AddFamily setOnAddFamily={setOnAddFamily} />}
      {onConfirmAddSubFamily && (
        <ConfirmAddSubFamily
          setOnConfirmAddSubFamily={setOnConfirmAddSubFamily}
          confirmSubFamilyModel={confirmSubFamilyModel}
          setIsCancel={setIsCancel}
        />
      )}
    </div>
  );
};
export default AddSubFamilies;
